import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const { refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const r = await api.get(`/billing/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          await refresh();
          return;
        }
        if (r.data.status === "expired" || attempts > 8) {
          setStatus("expired");
          return;
        }
        setTimeout(poll, 2000);
      } catch {
        if (attempts > 8) setStatus("error");
        else setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="card-bordered p-10 max-w-md w-full text-center fade-up" data-testid="billing-result">
        {status === "polling" && (<>
          <Loader2 className="w-10 h-10 spin text-[var(--accent)] mx-auto mb-4" />
          <div className="font-display text-2xl font-bold mb-2">Confirming your payment…</div>
          <div className="text-sm text-[var(--text-2)]">Hang tight.</div>
        </>)}
        {status === "paid" && (<>
          <CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto mb-4" />
          <div className="font-display text-2xl font-bold mb-2" data-testid="billing-success-title">You're in.</div>
          <div className="text-sm text-[var(--text-2)] mb-6">Welcome to Dynasty Metrics Pro. Your subscription is active.</div>
          <button onClick={() => nav("/app")} className="btn-primary w-full" data-testid="back-to-app">Go to terminal</button>
        </>)}
        {(status === "expired" || status === "error") && (<>
          <XCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
          <div className="font-display text-2xl font-bold mb-2">Something didn't go through.</div>
          <div className="text-sm text-[var(--text-2)] mb-6">No charge was made. You can try again any time.</div>
          <button onClick={() => nav("/pricing")} className="btn-primary w-full">Back to pricing</button>
        </>)}
      </div>
    </div>
  );
}
